import type { FC, PropsWithChildren } from 'react'
import { memo } from 'react'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { ChatNavigationContext } from '@app/pages/strategies/components/aiChat/contexts/aiChatNavigationContext'

type Props = {
  basePath: string
}

const RoutableAiChatNavigationProvider: FC<PropsWithChildren<Props>> = memo(({ basePath, children }) => {
  const navigate = useNavigate()
  const value = useMemo(
    () => ({
      show: (id: string) => {
        navigate(`${basePath}/${id}`)
      },
      list: () => {
        navigate(`${basePath}`)
      },
      new: () => {
        navigate(`${basePath}/new`)
      }
    }),
    [basePath, navigate]
  )

  return <ChatNavigationContext.Provider value={value}>{children}</ChatNavigationContext.Provider>
})

export default RoutableAiChatNavigationProvider
